/* eslint-disable no-console */
import { Contact, ContentPage, Office, PDFEditorialSpotItem } from 'models';
import slugify from 'slugify';
import { Translations } from 'store/translations';

export const getLinkToMore = (
  category: string,
  model: ContentPage | Contact | Office | PDFEditorialSpotItem,
  translations: Translations,
  taxonomyFilter: any,
) => {
  if (!model || model.system.type === 'pdf_editorial_spot_item') return '';

  let url = '';
  const urlCategory = taxonomyFilter?.taxonomyGroup;
  const urlCategoryValue = taxonomyFilter?.value[0]?.codename;

  // ✅ Build encoded query params safely
  const queryParams =
    urlCategory && urlCategoryValue
      ? `?${encodeURIComponent(translations.category(urlCategory.toLowerCase()))}=${encodeURIComponent(
          translations.segment(urlCategoryValue.toLowerCase()).toLowerCase(),
        )}`
      : '';
  switch (category) {
    case 'sector':
      url = `/${slugify(translations.sector((model as ContentPage).elements.tagsSector.value[0]?.codename), {
        lower: true,
      })}`;
      break;

    case 'project':
      url = `/${translations.multiple('project')}${queryParams}`;
      break;

    case 'insight':
      url = `/${translations.multiple('insight')}${queryParams}`;
      break;

    case 'product':
      url = `/${translations.multiple('product')}${queryParams}`;
      break;

    case 'news':
      url = `/${translations.multiple('news')}`;
      break;

    case 'service_line':
      url = `/${slugify(translations.service_line((model as ContentPage).elements.tagsServiceLine.value[0]?.codename), {
        lower: true,
      })}`;
      break;

    case 'office':
      url = `/${translations.multiple('contactUsUrl')}`;
      break;

    case 'people':
      url = `/${translations.multiple('contactUsUrl')}/${translations.url('peopleUrl')}`;
      break;

    default:
      url = '/';
      break;
  }

  // ✅ Clean up URL (remove duplicate slashes and undefined)
  return url.replace(/\/+/g, '/').replace(/undefined/g, '');
};
